import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/telegram",
    clipPath: "url(#clip_Telegram)"
  }, React.createElement("path", {
    id: "rect5234",
    d: "M15.9555 3.16465C16.0901 2.56013 15.9266 2.04497 15.368 2.00119L15.3681 2.00298C15.1819 1.98852 14.9518 2.02601 14.6743 2.13038L0.7499 7.37232C0.301374 7.54118 -0.646766 8.11626 0.676945 8.5217L4.11013 9.57206L4.77468 9.26298L12.6306 4.43511C12.7177 4.38194 12.8127 4.34791 12.8973 4.33228C13.1508 4.28869 13.3178 4.42104 12.9514 4.74002L6.31829 10.5132C6.26264 10.5612 6.25922 10.5932 6.25415 10.6408L6.25376 10.6445V14.2456L8.53287 12.2083L12.0556 14.701C12.7355 15.1819 13.2996 15.092 13.4618 14.3637L15.9555 3.16465Z",
    fill: "currentColor"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Telegram16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Telegram16 = createIcon(IconComponent);